/* Aurora patch: reels — tap-to-play with sound, one at a time, pause off-screen */
(function(){
'use strict';
function lockSectionScroll(){
  var sec=document.querySelector('.alx-insta');
  if(!sec||sec.hasAttribute('data-alx-sg'))return;
  sec.setAttribute('data-alx-sg','1');
  var rst=function(){if(sec.scrollTop)sec.scrollTop=0;};
  sec.addEventListener('scroll',rst,{passive:true});
  rst();
}
function wire(){
  lockSectionScroll();
  document.querySelectorAll('.alx-reel:not([data-alx-p2])').forEach(function(r){
    r.setAttribute('data-alx-p2','1');
    var vid=r.querySelector('video');
    if(vid){
      try{vid.autoplay=false;vid.removeAttribute('autoplay');vid.pause();}catch(e){}
      vid.loop=true;vid.playsInline=true;vid.setAttribute('playsinline','');vid.removeAttribute('controls');
      if(!r.querySelector('.alx-vplay')){
        var btn=document.createElement('span');btn.className='alx-vplay';
        btn.innerHTML='<svg viewBox=\"0 0 24 24\"><path d=\"M8 5v14l11-7z\"/></svg>';
        r.appendChild(btn);
      }
      function stopOthers(){
        document.querySelectorAll('.alx-reel.alx-playing video').forEach(function(v){
          if(v!==vid){v.pause();var rr=v.closest('.alx-reel');if(rr)rr.classList.remove('alx-playing');}
        });
      }
      function toggle(){
        if(vid.paused){
          stopOthers();
          vid.muted=false;vid.volume=1;
          var p=vid.play();
          if(p&&p.catch)p.catch(function(){vid.muted=true;vid.play().catch(function(){});});
          r.classList.add('alx-playing');
        }else{
          vid.pause();
          r.classList.remove('alx-playing');
        }
        /* browsers may auto-scroll the section internally on play — undo it */
        var sec=document.querySelector('.alx-insta');
        if(sec){sec.scrollTop=0;requestAnimationFrame(function(){sec.scrollTop=0;});}
      }
      r.addEventListener('click',function(e){
        if(e.target.closest('.alx-reel-ig'))return;
        toggle();
      });
      try{
        new IntersectionObserver(function(es){es.forEach(function(en){
          if(!en.isIntersecting&&!vid.paused){vid.pause();r.classList.remove('alx-playing');}
        });},{threshold:.2}).observe(r);
      }catch(e){}
      /* neutralize any earlier autoplay attempts */
      var guard=setInterval(function(){
        if(!r.classList.contains('alx-playing')&&!vid.paused){vid.pause();}
      },400);
      setTimeout(function(){clearInterval(guard);},6000);
      return;
    }
    /* poster/link tiles: open reel on tap */
    r.style.cursor='pointer';
    r.addEventListener('click',function(e){
      if(e.target.closest('.alx-reel-ig'))return;
      var url=(r.getAttribute('data-reel')||'').trim();
      var profile=r.getAttribute('data-profile')||'https://www.instagram.com/lensespk';
      window.open(url||profile,'_blank');
    });
  });
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',wire);}else{wire();}
document.addEventListener('shopify:section:load',wire);
})();
